<template>
    <div class="activityDetail">
        <!-- 活动帖 special ==4 时显示-->
        <div class="activity">
          <div class="top">
            <div class="img">
              <img width="100%" :src="thread.activity.thumb"/>
            </div>
            <div class="topDesc">
              <!-- 判断是否为拼团,是拼团显示'拼团价'字样 -->
              <div class="nm">
                ￥<em class="money">{{goodPrice?goodPrice:0}}</em><em class="ptm" v-if="isShowpt">拼团价</em>
              </div>
              <div class="subject">{{thread.subject}}</div>
              <div class="des">
                <div class="des_block">阅读<span>{{thread.views?thread.views:0}}</span></div>
                <div class="des_block">分享<span>{{thread.shareNum?thread.shareNum:0}}</span></div>
                <!-- 区分报名和购买 ??-->
                <!-- activity.ext_needsign<=1 显示报名 否则显示购买-->
                <div class="des_block bm" v-if="activityObj.ext_needsign<=1">
                  报名<span>{{activityObj.activitynumber}}</span>
                </div>
                <div class="des_block buy" v-else>
                  购买<span>{{activityObj.applynumber}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="cen">
            <div class="mainTop">
              <div class="item tips" @click="showMask"  v-if="activityObj.backups.length!=0">
                <div class="le">说明</div>
                <div class="ri backups"  v-for="(item,i) in activityObj.backups" :key="i">
                  {{item}} ·&nbsp;
                </div>
              </div>
              <div class="item">
                <div class="le">地址</div>
                <div class="ri addr">
                  {{activityObj.activityplace}}
                </div>
              </div>
              <div class="item">
                <div class="le">截止</div>
                <div class="ri dateline">{{thread.activity.starttimeto| momentDate}}</div>
              </div>
              <div class="item">
                <div class="le">客服</div>
                <div class="ri cus_ser">
                  <span @click="showMaskCusSer">点击加微信咨询</span>
                </div>
              </div>
            </div>
            <div class="userInfo">
              <img class="imgs" :src="thread.avatar?thread.avatar:'../../assets/imgs/noavatar_big.gif'" />
              <div class="ri">
                <div class="name">{{thread.author?thread.author:'邻友'}}</div>
                <div>活动主办方</div>
              </div>
            </div>
          </div>
          <div class="Top_title">内容详情</div>
          <div class="footer">
            <!-- 没结束的 starttimeto > curtime -->
            <div v-if="starttimeto > curTime">
                <!-- 报名截止  activityexpiration < curTime -->
                <div v-if="activityexpiration < curTime">
                    <div class="item bmDeadline gray"  @click="intoDownlyq">
                      报名已截止
                    </div>
                </div>
                <div v-else>
                    <!-- 进行中 -->
                    <!-- 拼团 activity.ext_needsign==5-->
                    <div v-if="ext_needsign ==5">
                        <div class="item pt" @click="intoDownlyq">
                          <div class="leftOrange">
                            <span>￥{{minPrice?minPrice:'0'}}</span><br />
                            <span class="alone">单独购买</span>
                          </div>
                          <div class="rightOrange">
                            <span>￥{{groupminIndex?groupminIndex:'0'}}</span><br />
                            <span class="startPt">发起拼团</span>
                          </div>
                        </div>
                    </div>
                    <!-- 商品 activity.ext_needsign==3 -->
                    <div v-if="ext_needsign==3">
                      <!-- 分为立即兑换和已售罄 -->
                      <div v-if="applynumber >= amount">
                        <div class="item sq" @click="intoDownlyq">
                          已售罄
                        </div>
                      </div>
                      <div v-else>
                          <div class="item sp" @click="intoDownlyq">
                            立即兑换
                          </div>   
                      </div>
                    </div>
                    <!-- 活动 activity.ext_needsign<=1-->
                    <div v-if="ext_needsign <=1">
                        <div class="item activity green" @click="intoDownlyq">
                          <div class="innerLeft">免费发活动</div>
                          <div class="innerRight">我要报名</div>
                        </div>
                    </div>
                </div>
            </div>
            <!--已结束的 starttimeto < curtime -->
            <div v-else>
                <div class="item activityOver gray"  @click="intoDownlyq">
                  活动已结束
                </div>
            </div>
            
          </div>
          <!-- 说明遮罩 -->
		  <div class="descMask" v-show="isshowMask">
        <div class="maskBox">
          <div class="txt">活动说明</div>
          <div  v-for="(item,i) in activityObj.backups" :key="i">
            <div class="desc">{{item}}</div>
          </div>
          <img class="close" @click="closeMask" src="@/assets/imgs/c2.png" mode="">
        </div>
		  </div>
          <!-- 客服微信弹窗 -->
      <div class="descMask" v-show="isshowWei">
        <div class="maskBox">
          <div class="title">加客服咨询相关问题</div>
          <div>
            <div class="wImg">
                <img src="@/assets/imgs/ccode.jpg">
            </div>
            <div style="text-align:center;margin:0 0 15px 0">提示：微信扫一扫添加好友</div>
          </div>
          <div @click="closeWMask" class="iknow">我知道了</div>
        </div>
		  </div>
          <!-- 下载 -->
      <div class="descMask" v-show="intoDownloadLyq">
              <div class="maskBox">
                  <div class="code" id="qrcode" ref="qrcode">
                  </div>
                  <div class="descTxt">邻友圈App或微信扫一扫参与互动</div>
                    <div class="closeR" @click="closefoot"><img  src="@/assets/imgs/c2.png"></div>
                  </div>
              </div>
      </div>
    </div>
</template>
<script>
import moment from 'moment'
import QRCode from 'qrcodejs2'
export default {
  props:['thread'],
  data() {
    return {
        isshowMask:false,
        isshowWei:false,
        intoDownloadLyq:false,
        activityObj:this.thread.activity,
        goodPrice:'',//活动顶部拼团价
        isShowpt:false,//显示拼团价
        curTime:moment().format('X'),
        starttimeto:this.thread.activity.starttimeto, 
        activityexpiration:this.thread.activity.activityexpiration,
        ext_needsign:this.thread.activity.ext_needsign,
        amount:0,
        applynumber:this.thread.activity.applynumber,
        QRCodetext:`https:${this.commonIp}/v1/threads/`+this.thread.tid,
        minPrice:'', //单买最小价格
				groupminIndex:'',//拼团最小价格
    };
  },
  mounted(){
    this.initData()
    console.log(this.curTime)
    console.log(this.starttimeto)
    this.$nextTick(()=>{
      this.qrcode()
    })
  },
  filters:{
    momentDate(date) {
      return moment(date * 1000).format("YYYY-MM-DD HH:mm");
    },
  },
  methods: {
      showMask(){
          this.isshowMask = true
      },
      closeMask(){
          this.isshowMask = false
      },
      showMaskCusSer(){
          this.isshowWei = true
      },
      closeWMask(){
          this.isshowWei = false
      },
      intoDownlyq(){
          this.intoDownloadLyq = true
      },
      closefoot(){
          this.intoDownloadLyq = false
      },
      qrcode() {
        let qrcode = new QRCode(this.$refs.qrcode, {
          width: 200,
          height: 200,
          text: this.QRCodetext ? this.QRCodetext : '',
          colorDark: '#000',
          colorLight: '#fff',
          correctLevel: QRCode.CorrectLevel.H
        })
      },
      initData(){
        console.log(this.thread)
				let {options} = this.thread.activity
				let optionsType = Object.prototype.toString.call(options).slice(8,-1).toUpperCase()
        if(optionsType === 'OBJECT'){
          let val = '',max = '',min=''
          if (options.groupBuyGoods && Array.isArray(options.groupBuyGoods) && options.groupBuyGoods.length!=0) {
						//获取拼团价格区间
						max = Math.max.apply(null,options.groupBuyGoods.map(item => item.price))
						min = Math.min.apply(null,options.groupBuyGoods.map(item => item.price))
						this.isShowpt = true
					}else{
						this.isShowpt = false
						max = Math.max.apply(null,options.goods.map(item => item.price))
						min = Math.min.apply(null,options.goods.map(item => item.price))
					}
					if(min==max) {
						val =  min
					}else {
						val = `${min}~${max}`
					}
					this.goodPrice = val

          if (options.goodsNumbers && Array.isArray(options.goodsNumbers)) {
						let arr = this.thread.activity.options.goodsNumbers
						let amount = 0
            arr.forEach(function(value,index,arrSelf){
							arrSelf[index] = value;
							amount+=value.number;
						});
            this.amount=amount
          }
          if(options.goods  && Array.isArray(options.goods)){
							let arrgoods= this.thread.activity.options.goods
							this.minPrice = Math.min.apply(Math, arrgoods.map(function(o) {return o.price}))
					}
					if(options.groupBuyGoods  && Array.isArray(options.groupBuyGoods)){
							let arrgroupBuyGoods= this.thread.activity.options.groupBuyGoods
							this.groupminIndex = Math.min.apply(Math, arrgroupBuyGoods.map(function(o) {return o.price}))
					}
        }

      }
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/less/index.less";
.activityDetail{
    // 活动
    .activity {
      .top {
        margin: 20px 0;
        .img {
          img {
            width: 100%;
          }
        }

        .topDesc {
          color: #ff4c45;

          .nm {
            margin-top: 10px;
            font-size: 12px;

            .money {
              font-style: normal;
              font-size: 18px;
              display: inline-block;
              margin-right: 10px;
            }

            .ptm {
              font-style: normal;
              font-size: 12px;
            }
          }

          .subject {
            color: #333;
            font-size: 18px;
            margin: 10px 0;
          }

          .des {
            width: 100%;
            display: inline-flex;

            .des_block {
              font-size: 16px;
              color: #999;
              flex: 1;

              &:nth-child(1) {
                text-align: left;
              }

              &:nth-child(2) {
                text-align: center;
              }
            }

            .buy {
              text-align: right;
            }
            .bm{
              text-align: right;
            }
          }
        }
      }
      .cen {
        .mainTop {
          margin-top: 20px;
          .tips{
           cursor: pointer; 
           background:url("~@/assets/imgs/a.png") no-repeat right center;
		   background-size:6px;
          }
          .item {
            line-height: 30px;
            display: flex;

            .le {
              width: 50px;
            }
            .ri {
              // flex: 1;
            }
            .cus_ser{
                cursor: pointer;
                color: #55aa7f;
            }
          }
        }

        .userInfo {
          margin: 30px 0;
          .imgs {
            width: 50px;
            height: 50px;
            border-radius: 2px;
            float: left;
            display: inline-block;
            margin-right: 10px;
          }

          .ri {
            .name {
              font-size: 18px;
              margin-bottom: 5px;
            }
          }
        }
      }
      .footer {
        .item {
          cursor: pointer;
          z-index: 99;
          position: fixed;
          width: 100%;
          max-width: 752px;
          bottom: 0;
          height: 50px;
          color: #333;
          font-size: 16px;
        }
        .activity {
          display: inline-flex;
          text-align: center;
          .innerLeft {
            color: #333;
            width: 30%;
            background-color: #f2f2f2;
          }
          .innerRight {
            color: #fff;
            width: 70%;
            background-color: #55aa7f;
          }
        }
        // .hand{
        //   display: inline-flex;
        //   text-align: center;
        //   .innerLeft{
        //     color: #333;
        //     width: 30%;
        //     background-color: #f2f2f2;
        //   }
        //   .innerRight{
        //     color: #fff;
        //     width: 70%;
        //     background-color: #e44100;
        //   }
        // }
        .gray {
          background-color: #f2f2f2;
          color: #333;
          text-align: center;
          line-height: 50px;
        }
        .sp{
          background-color: orangered;
          color: #fff;
          text-align: center;
          line-height: 50px;
        }
        .sq {
          background-color: #f2f2f2;
          color: #333;
          text-align: center;
          line-height: 50px;
        }
        .green {
          background-color: #55aa7f;
          color: #fff;
          text-align: center;
          line-height: 50px;
        }
        .pt {
          display: inline-flex;
          color: #fff;
          text-align: center;
          .leftOrange {
            width: 30%;
            background-color: #ffc986;
          }
          .rightOrange {
            width: 70%;
            background-color: #ff6b3a;
          }
        }
      }
      .Top_title {
      box-sizing: border-box;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      color: #323232;
      position: relative;
      text-align: center;

      &::before {
        position: absolute;
        display: block;
        content: "";
        width: 100px;
        height: 1px;
        right: 28%;
        top: 50%;
        background: #979797;
      }
      &::after {
        position: absolute;
        display: block;
        content: "";
        width: 100px;
        height: 1px;
        left: 28%;
        top: 50%;
        background: #979797;
      }
    }
    .descMask{
			position: fixed;
			top:0;
			left:0;
			width:100%;
			height: 100%;
			background: rgba(0,0,0,.7);
			z-index: 9999;
			.maskBox{
				width:40%;
				padding:45px 35px;
				box-sizing: border-box;
				background:#fff;
				border-radius:5px;
				position: absolute;
				top: 40%;
				left: 50%;
				transform: translate(-50%, -40%);
				.close{
                    cursor: pointer;
					position: absolute;
					bottom:-36px;
					left:50%;
					width:20px;
					height: 20px;
					margin-left:-26px;
				}
				.txt{
					text-align: center;
					margin:0 0 20px 0;
				}
				.desc{
					font-size:15px;
					margin:0 0 10px 0;
					padding:0 0 0 30px;
					background:url("~@/assets/imgs/ts.png") no-repeat left center;
					background-size:10px 10px;
				}
                .wImg{
                    width: 200px;
                    margin: 20px 0;
                    text-align: center;
                    margin: 0 auto;
                    img{
                        display: block;
                        width: 200px;
                        height: 200px;
                        
                    }
                }
                .title{
                    margin:0 0 20px 0;
                    text-align: center;
                }
                .iknow{
                    color: #55aa7f;
                    cursor: pointer;
                    text-align: center;
                }
                .code{
                    width: 200px;
                    margin: 0 auto;
                    img{
                        width: 200px;
                        height: 200px;
                        display: block;
                    }
                }
                .descTxt{
                    margin: 10p 0;
                    font-size: 18px;
                    text-align: center;
                }
                .closeR{
                    position: absolute;
                    right: 15px;
                    top: 15px;
                    img{
                        display: block;
                        width: 20px;
                        height: 20px;
                        cursor: pointer;
                    }
                }
			}
		}
    }
}
</style>
<style lang="less" scoped>
.descTxt{
  margin-top: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/activity/activity.vue